import { footer, pageHead } from "../chrome";
import { el } from "../dom";
import { nav } from "../nav";

/**
 * A phone cannot play a match, so it is told that instead of being let into
 * one.
 *
 * A match is MegaMek's own desktop client drawn into a canvas — a fixed
 * layout meant for a mouse, a keyboard and a screen with room for a hex map
 * and four panels beside it. None of that degrades on a phone: it renders,
 * it takes taps, and it is unplayable. A player who finds that out from a
 * lobby they have already sat somebody else down in has spent an opponent's
 * time as well as their own.
 *
 * So the gate is on the way in rather than a warning inside. It stands in for
 * Play and for a lobby, which are the two screens that lead to a match, and
 * for the daily fight, which is the third way into one. Everything else the
 * site does — reading About, designing a camo, looking at a pilot page, the
 * blog — is unaffected: those pages work at a phone's width and are the
 * reason site-a11y's rules exist.
 *
 * Not dismissible, and no "play anyway". The support answer is no, and a gate
 * that can be clicked through is a warning wearing a gate's clothes.
 */

/**
 * The screen a phone gets where a match would have been.
 *
 * Home rather than Back: the address that got here is a match address, and
 * every one of them ends at this same card. Home is a page the phone can
 * actually use.
 */
export function phoneGateScreen(): Node[] {
  const home = el("button", { type: "button", textContent: "Go home" });
  home.addEventListener("click", () => {
    window.history.replaceState({}, "", "/");
    void nav.start!();
  });

  return [
    pageHead(
      "Phones are not supported",
      "A match runs MegaMek's desktop interface, which needs a mouse and a screen to fit it.",
    ),
    el("section", { className: "card" }, [
      el("p", {
        className: "hint",
        textContent:
          "Open lance.blue on a desktop or a laptop to play. The rest of the site works here.",
      }),
      el("div", { className: "row" }, [home]),
    ]),
    footer(),
  ];
}
